export default function adminLinksReducer(state = {
  links: {},
  fetching: false,
  fetched: false
}, action) {
  switch (action.type) {
    case 'GET_ADMIN_LINKS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      };
    }
    case 'GET_ADMIN_LINKS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        links: action.payLoad.data,
        meta: action.payLoad.meta,
      };
    }
    case 'GET_ADMIN_LINKS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}
